<template>
    <pg-page title="Private Gym Reviews"
             header="Private Gym Reviews"
             id="kracht-en-conditie-training"
    >

        <div class="row">
            <all-reviews></all-reviews>
        </div>

        <div class="row">
            <div class="col my-5 py-5 text-center">
                <h1 class="mb-5">
                    <strong>
                        Kom even de sfeer proeven! Plan een rondleiding of stel je vraag via Whatsapp!
                    </strong>
                </h1>
                <action-buttons :show-whatsapp="true" :show-inschrijven="true" :colored="true" :icon="true"></action-buttons>
            </div>
        </div>

    </pg-page>
</template>

<script>

import PgPage from "../Components/PgPage";
import ContactModal from "../Components/Contact/ContactModal";
import RondleidingButton from "../Components/Index/RondleidingButton";
import HeaderAndTextBlock from "../Components/Layout/HeaderAndTextBlock";
import ActionButtons from "../Components/Index/ActionButtons";
import ReviewBox from "../Components/Reviews/ReviewBox";
import AllReviews from "../Components/Reviews/AllReviews";

export default {
    components: {AllReviews, ReviewBox, ActionButtons, HeaderAndTextBlock, RondleidingButton, ContactModal, PgPage},

    props: [],

    mixins: [],

    data: function () {
        return {
            //
        };
    },

    computed: {
        //
    },

    created() {
        //
    },

    mounted() {
        //
    },

    methods: {
        //
    },

    watch: {
        //
    }
};
</script>
